import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "19",
  viewBox: "0 0 20 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.32422 3H3.32422C2.21965 3 1.32422 3.89543 1.32422 5V16C1.32422 17.1046 2.21965 18 3.32422 18H14.3242C15.4288 18 16.3242 17.1046 16.3242 16V11M14.91 1.58579C15.6911 0.804738 16.9574 0.804738 17.7384 1.58579C18.5195 2.36683 18.5195 3.63316 17.7384 4.41421L9.15264 13H6.32422L6.32422 10.1716L14.91 1.58579Z",
      stroke: "currentColor",
      "stroke-opacity": "0.87",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }